import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resolveLanguage } from "./locale";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import cy from "./locales/cy.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import nl from "./locales/nl.json";
import pl from "./locales/pl.json";
import pt from "./locales/pt.json";
import ru from "./locales/ru.json";
import ur from "./locales/ur.json";
import zh from "./locales/zh.json";
import zhHant from "./locales/zh-hant.json";

// Same normalization the API request interceptor uses (src/axios.js) —
// resolveLanguage() returns undefined for English/unsupported locales, so
// the UI falls back to `en` exactly like the API falls back to its default.
const lng = resolveLanguage() || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
    cy: { translation: cy },
    de: { translation: de },
    es: { translation: es },
    fr: { translation: fr },
    nl: { translation: nl },
    pl: { translation: pl },
    pt: { translation: pt },
    ru: { translation: ru },
    ur: { translation: ur },
    zh: { translation: zh },
    "zh-hant": { translation: zhHant },
  },
  lng,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export default i18n;
